(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('team-management', {
                parent: 'admin',
                url: '/team',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN'],
                    pageTitle: 'teamManagement.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/admin/team-management/team-management.html',
                        controller: 'TeamManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: null,
                    itemsPerPageChosen: null,
                    predicates: {},
                    status: ''
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search,
                            status: $stateParams.status

                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('team-management');
                        $translatePartialLoader.addPart('invitation');
                        return $translate.refresh();
                    }]
                }
            })
            .state('team-management-detail', {
                parent: 'admin',
                url: '/team/:login',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN'],
                    pageTitle: 'teamManagement.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/admin/team-management/team-management-detail.html',
                        controller: 'TeamManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('team-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('team-management-edit', {
                parent: 'team-management',
                url: '/{login}/edit',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN'],
                    pageTitle: 'teamManagement.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/admin/team-management/team-management-dialog.html',
                        controller: 'TeamManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['Team','$stateParams', function (Team, $stateParams) {
                        return Team.get({login: $stateParams.login});
                    }],
                    domain: ['Principal', 'TabDomains', '$q', function (Principal, TabDomains, $q) {
                        var domain = $q.defer();
                        Principal.identity().then(function (data) {
                            domain.resolve(TabDomains.get({id: data.context.id}));
                        });
                        return domain.promise;
                    }]
                }
            })
            .state('team-management-alerts', {
                parent: 'team-management',
                url: '/{login}/alerts',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN'],
                    pageTitle: 'entity.action.alertSystem'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/admin/team-management/team-management-alert-system.html',
                        controller: 'TeamManagementAlertSystemController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        squash: true
                    },
                    systemPage: {
                        value: '1',
                        squash: true
                    },
                    systemSort: {
                        squash: true
                    },
                    search: null,
                    predicates : {},
                    systemPredicates : {},
                    itemsPerPageChosen: null
                },
                resolve: {
                    entity: ['Team','$stateParams', function (Team, $stateParams) {
                        return Team.get({login: $stateParams.login});
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            systemPage: PaginationUtil.parsePage($stateParams.systemPage),
                            systemSort: $stateParams.systemSort,
                            predicates : $stateParams.predicates,
                            systemPredicates : $stateParams.systemPredicates,
                            search: $stateParams.search
                        };
                    }],
                    domain: ['Principal', 'TabDomains', '$q', function (Principal, TabDomains, $q) {
                        var domain = $q.defer();
                        Principal.identity().then(function (data) {
                            domain.resolve(TabDomains.current());
                        });
                        return domain.promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('alertRules');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('team-management-delete', {
                parent: 'team-management',
                url: '/{login}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/team-management/team-management-delete-dialog.html',
                        controller: 'TeamManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Team', function (Team) {
                                return Team.get({login: $stateParams.login});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('team-management', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
